import React, { useEffect, useRef, useState } from "react";
import HeroSection from "./sections/HeroSection";
import FeaturesSection from "./sections/FeaturesSection";
import RecentObituariesSection from "./sections/RecentObituariesSection";
import PopularWreathsSection from "./sections/PopularWreathsSection";
import NoticesSection from "./sections/NoticesSection";
import CTASection from "./sections/CTASection";

/**
 * Reveal - 스크롤 진입 시 페이드인/슬라이드업 마이크로인터랙션.
 * IntersectionObserver 로 뷰포트 진입을 감지하며, 미지원/감속 선호 시 즉시 노출.
 */
const Reveal = ({ children, className = "" }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    // 접근성: 모션 최소화 선호 시 애니메이션 없이 즉시 표시
    const prefersReduced =
      typeof window !== "undefined" &&
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (prefersReduced || typeof IntersectionObserver === "undefined") {
      setVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out ${
        visible
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-8"
      } ${className}`}
    >
      {children}
    </div>
  );
};

const HomePage = () => {
  // SEO/접근성: 문서 타이틀 설정
  useEffect(() => {
    const prevTitle = document.title;
    document.title = "모바일 장례 서비스 | 부고 작성과 화환 주문";
    return () => {
      document.title = prevTitle;
    };
  }, []);

  return (
    <main className="bg-ivory min-h-screen">
      {/* Hero 는 첫 화면이므로 즉시 노출 */}
      <HeroSection />
      <Reveal>
        <FeaturesSection />
      </Reveal>
      <Reveal>
        <RecentObituariesSection />
      </Reveal>
      <Reveal>
        <PopularWreathsSection />
      </Reveal>
      <Reveal>
        <NoticesSection />
      </Reveal>
      <Reveal>
        <CTASection />
      </Reveal>
    </main>
  );
};

export default HomePage;
